import { getDefaultWallets } from '@rainbow-me/rainbowkit';
import { createConfig, http } from 'wagmi';
// Only using Sonic Blaze testnet
import { injected } from 'wagmi/connectors';
import { sonicBlaze } from '../lib/chains';

// Get WalletConnect Project ID from environment variables
const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || '78b00bb8d9f53637069ee1f33cd513e4';

// Define chains once
export const chains = [sonicBlaze];

// Create a singleton for wallet configuration
const { connectors } = getDefaultWallets({
  appName: 'FTTF.World',
  projectId,
  chains,
});

// Create the config once to avoid multiple initializations
let wagmiConfig: ReturnType<typeof createConfig> | null = null;

// Initialize the config only once
const initializeWagmiConfig = () => {
  if (wagmiConfig) return wagmiConfig;
  
  wagmiConfig = createConfig({
    chains,
    transports: {
      [sonicBlaze.id]: http(),
    },
    connectors: [
      injected({
        shimDisconnect: true,
      }),
      ...connectors
    ],
  });
  
  return wagmiConfig;
};

export const getWagmiConfig = () => initializeWagmiConfig();